module.exports = __webpack_public_path__ + "assets/img/1688logo.75263e0f.svg";